import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Calls the provided callback when the user navigates to a different route.
 * Useful for closing modals, sidebars, or other overlays on navigation.
 */
export function useCloseOnNavigation(onClose: () => void) {
  const router = useRouter();

  useEffect(() => {
    return router.subscribe('onBeforeLoad', onClose);
  }, [router, onClose]);
}
